import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {languages} from '@/i18n/index'
import {defaultLocale} from '@/i18n/index'
//import { messages } from './plugins/translations'

Vue.use(VueI18n)

//Create VueI18n instance with options
// setup localized messages
export const messages = Object.assign(languages)
export const i18n = new VueI18n({
    locale: navigator.language,
    fallbackLocale: defaultLocale,
    messages,
    silentTranslationWarn: true
})

/* export const i18n = new VueI18n({
  locale: 'de', // set locale
  messages      // set messages 
}) */
